import { dateFormatter } from '../../../utils/DateFormatter'
import {
  LotFilenameTemplateItem,
  MaterialRequirementFilenameTemplateItem,
  MaterialSourceFilenameTemplateItem,
} from '../classes/density'
import { defaultsTo } from '../utils'

export const DensityLotDate = new LotFilenameTemplateItem({
  id: '8FABF850-DC51-469F-83EE-082382ECE4B1',
  name: 'Lot Date',
  property: 'dateLotCreated',
  help: `Uses the earliest Test Date of any associated Density Tests. ${defaultsTo(
    { name: 'Test Date', property: 'Lot Date' }
  )}. ${defaultsTo({
    name: 'Lot Date',
    property: 'Created Date',
  })}`,
  exampleValue: () => dateFormatter(null).file(new Date()),
})

export const DensityLotId = new LotFilenameTemplateItem({
  id: 'B441E271-0729-4F7A-8419-61AF27AC29CB',
  name: 'Lot ID',
  property: 'lotId',
  help: 'Lot ID from Lot table',
  exampleValue: 'PLA-0014',
})

export const DensityLotMaterialSource = new MaterialSourceFilenameTemplateItem({
  id: '537AF709-2F8A-4352-A6E2-E45ACFB22C9A',
  name: 'Material Source',
  property: 'source',
  help: 'Source from Material Source table',
  exampleValue: '2 inch Borrow - Weber Pit',
})

export const DensityLotClassification = new MaterialSourceFilenameTemplateItem({
  id: '251A19D8-37B3-412D-A60C-A36EBDAB2CB3',
  name: 'Classification',
  property: 'classification',
  help: 'Classification from Material Source table',
  exampleValue: 'A-1-a',
})

export const DensityLotMaterialSection =
  new MaterialRequirementFilenameTemplateItem({
    id: '260407E3-F257-4428-A27E-EA6B19CBA987',
    name: 'Material Section/Requirements',
    property: 'materialSection',
    help: 'Material Section from Material Requirements table',
    exampleValue: 'Granular Backfill Borrow',
  })

export const DensityLotShortName = new MaterialRequirementFilenameTemplateItem({
  id: 'E46F0C20-8657-43C2-B06B-18D06EB5C59F',
  name: 'Material Section/Requirements Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Material Requirements table',
  exampleValue: 'GBB',
})

export type DensityFilename =
  | typeof DensityLotDate
  | typeof DensityLotId
  | typeof DensityLotMaterialSource
  | typeof DensityLotClassification
  | typeof DensityLotMaterialSection
  | typeof DensityLotShortName
